import { Box } from '@chakra-ui/react';
import { SingleDatepicker, SingleDatepickerProps } from 'chakra-dayzed-datepicker';
import { useCallback, useState } from 'react';
import configs from './datepicker.config';

export default function CustomSingleDatepicker({ date: initialDate, onDateChange, ...props }: Partial<SingleDatepickerProps>) {
  const [date, setDate] = useState<Date | undefined>(initialDate);

  const handleChangeDate = useCallback((date: Date) => {
    setDate(date);
    if (onDateChange)
      onDateChange(date);
  }, [onDateChange]);

  return (
    <Box w="135px" zIndex={0} pos="relative">
      <SingleDatepicker
        date={date}
        onDateChange={handleChangeDate}
        triggerVariant="input"
        configs={configs}
        propsConfigs={{
          inputProps: {
            minW: '135px',
            pointerEvents: 'none'
          }
        }}
        {...props}
      />
    </Box>
  )
}
